module.exports = {
	"Home": {
		"bloc1": {
			"title": "A friend wishing you well.",
			"content1": "Meet people recommended by friends.",
			"content2": "Create potential couples in a fun way.",
			"content3": "To experience meaningful encounters.",
			"content4": "Available on all stores.",
			"content5": "Be part of an amazing experience.",
			"downloadiOs": "Download Chaperon on AppStore",
			"downloadAndroid": "Download Chaperon on PlayStore"
		},
		"bloc2": {
			"title": "What is Chaperon?",
			"name": "Chaperon (n.m.)",
			"def": "escort, guarantee, protector, protection",
			"content1": "Chaperon is a dating app of a new kind. Or you will evolve in a benevolent environment and who better than your friends can advise you (if it is not the case, it will be necessary to choose them wisely or to think to change them)"
		},
		"bloc3": {
			"title": "Who is Chaperon for?",
			"content1": "Join the Chaperon community depending on your current situation, as a couple or single, you will always have a role to play. The question being what will be yours?",
			"chaperon-header": "Embody this friend and suggests as you would in real life connections in your circle of friends.",
			"chaperon-block1-title": "Create couples",
			"chaperon-block1-content": "Give a boost to destiny solo, or duet, the union is strength ...",
			"chaperon-block2-title": " Earn points",
			"chaperon-block2-content": "Be rewarded with quality matches, which will make you reach the top",
			"chaperon-block3-title": "Commmunicate",
			"chaperon-block3-content": "Improve your match proposals by talking with your chappies or co-chaperons.",
			"chappy-header": "Discover proposals and exchange with your Chaperons and if you feel like it, also take the role of Chaperon",
			"chappy-block1-title": "Receive predictions",
			"chappy-block1-content": "The collective intelligence of all Chaperons at your service, so even more proposals.",
			"chappy-block2-title": "The Chaperon Assistant",
			"chappy-block2-content": "Our I.A. will introduce you beautiful people to meet.",
			"chappy-block3-title": "Evaluate",
			"chappy-block3-content": "Express your opinion on the activity of your Chaperon (it remains totally anonymous)."
		},
		"bloc4": {
			"title": "The genesis",
			"content1": "Chaperon was born of a mixed feeling about the dating offer and the experience of a missed date through a friend.",
			"genese-block1-title": "Discovery of dating apps",
			"genese-block1-content1": "- Hey bro! take a look at this app!",
			"genese-block1-content2": "- Well OK, why not!",
			"genese-block2-title": "Back to basics",
			"genese-block2-content1": "- My friend, I have someone to introduce you",
			"genese-block2-content2": "- Ok it does not bind to anything!",
			"genese-block3-title": "The truth that hurts",
			"genese-block3-content": "A mixed feeling about dating apps and a date that never takes place.",
			"genese-block4-title": "The revelation",
			"genese-block4-content": "This \"EUReKa\" moment where we transform what was just an idea into something concrete.",
			"motto": "A friend wishing you well."
		},
		"bloc5": {
			"title": "Because you have to know how to relax.",
			"content1": "Take a moment to try our quizzes and find out what kind of chaperon you are :).",
			"quizz-woman": "Woman Quiz",
			"quizz-man": "Man Quiz"
		},
		"bloc6": {
			"title": "They talk about us on Instagram",
			"content1": "Want to know a little more about Chaperon, listen to what our influencers have to say",
			"appstore": "the Apple Store ",
			"playstore": "PlayStore",
			"content2": "or on",
			"content3": ", prepare to join our community and from our side we continue to do our best to offer you the best possible experience. Do not hesitate to talk about it around you. The more we are Chaperons, the more we Chaperon .. That's right? :)"
		}
	},
	"Footer": {
		"about": "About",
		"terms": "Terms of use",
		"privacy": "Privacy",
		"chaperon-insta": "Chaperon on Instragram",
		"chaperon-fb": "Chaperon on Facebook"
	},
	"Header": {
		"home": "Home",
		"about": "About",
		"quizz": "Quiz",
		"faq": "FAQ",
		"shop": "Shop",
		"shop-title": "Chaperon Shop",
		"beta": "BETA",
		"influenceur": "Influencers"
	},
	"FAQ": {
		"bloc1": {
			"title": "General questions",
			"q1": "I am in a relationship can I use Chaperon?",
			"a1": "Yes totally and it is even more fun with 2 people, and by taking the role of Chaperon you will not appear in the list of potential chappies and your profile will never be proposed.",
			"q2": "What is the DUO option for?",
			"a2": "Chaperone being more fun with 2 people, the DUO option allows you to do co-chaperoning. You can cross your circle of friends with that of another friend and increase your potential in terms of matches.",
			"q3": " If I connect with facebook or google will information be posted on my wall?",
			"a3": "Be reassured (e) nothing will be displayed on your wall and generally nothing will be done without your prior agreement.",
			"q4": "How do I find my friends on Chaperon?",
			"a4": "You can search them via the search field if they are present, otherwise you can invite them via your phonebook",
			"q5": "What is the key for?",
			"a5": " When a person invites or makes a match with one or more persons not present on Chaperon, the latter receive a message (SMS or email) containing a key, which they will be able to enter during the registration and which will enable him to find his friends as well as the matches that will have been proposed to him if it is a Chappy",
			"q6": "How many proposals can I receive from the Chaperon assistant?",
			"a6": "One a day in the best case, but it will depend on your network the more friends you have and the more the assistant will be able to make you proposals",
			"q7": "Why a selfie is asked to Chappies for the main photo?",
			"a7": "Chaperon relies on trust, so we need a selfie from you! Be reassured! You will be able to add other beautiful photos of your gallery once registered",
			"q8": "Can I match people who are not yet on the app?",
			"a8": "This is quite possible, besides when you select these people from your repertory, an invitation is sent. But these games will be active only when the person has validated his registration on the app and accepted your invitation.",
			"q9": "What does the colors of circles on profile pictures mean?",
			"a9": " Each of the colors is associated with the mood that you have defined as Chappy, or the one defined by your Chaperone if you have allowed it",
			"mood-blue": "Blue for Serious",
			"mood-green": "Green for Friendly",
			"mood-red": "Red for Open",
			"help": "If you do not find answers to your questions, contact us at hello@chaperon.me"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/resources/locales/en.json
// module id = 17
// module chunks = 0